import "./styles.css";
import Nav from "./Nav";
import TaskContainer from "./TaskContainer";
export default function App() {
  return (
    <div className="App">
      <Nav />
      <TaskContainer />
    </div>
  );
}